import CategoryFilter from './CategoryFilter'

export default CategoryFilter
